import { render } from "./CompanyPolicySection.vue?vue&type=template&id=6d1f8988"
import script from "./CompanyPolicySection.vue?vue&type=script&lang=js"
export * from "./CompanyPolicySection.vue?vue&type=script&lang=js"

import "./CompanyPolicySection.vue?vue&type=style&index=0&id=6d1f8988&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__